<script setup lang="ts">
import type { NuxtError } from '#app';
import { match } from 'ts-pattern';

const props = defineProps<{
  error: NuxtError;
}>();

// To trigger transition right after component mounts.
const isMounted = ref(false);
onMounted(() => {
  isMounted.value = true;
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
});

const message = computed(() => {
  return match(props.error.statusCode)
    .with(404, () => 'Stránka neexistuje')
    .otherwise(() => 'Něco se pokazilo');
});
const text = { button: 'Zpět na hlavní stránku' } as const;
</script>

<template>
  <div class="font-nature-variable relative text-white">
    <NuxtLayout>
      <PageContainerAlignment
        class="text-client-black flex h-screen w-full flex-col items-center justify-center"
      >
        <Transition appear>
          <div v-show="isMounted" class="gap-r4 flex flex-col items-center">
            <h1 class="text-3xl">{{ message }}</h1>
            <AppButton
              type="button"
              transition
              @click="clearError({ redirect: '/' })"
            >
              {{ text.button }}
            </AppButton>
          </div>
        </Transition>
      </PageContainerAlignment>
    </NuxtLayout>
  </div>
</template>

<style scoped lang="css">
.v-enter-active,
.v-leave-active {
  transition: transform, opacity;
  transition-duration: 700ms;
  transition-timing-function: ease-out;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateY(-32px);
}
</style>
